/**
 * Validation to detect valid ASCII characters. Accents and accented characters are not supported.
 *
 * @see https://www.asciitable.com/
 * @param {string} string
 * @return {boolean}
 */
const hasValidASCIICharacters = (string = '') => {
    // true if password does not contain a character outside 32 to 126 range
    return !!string.length && !/[^ -~]/g.test(string);
};

export default hasValidASCIICharacters;
